import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import chatbotImage from "./Images/chatbot.png";
import chatbotIcon from "./Images/ChatbotIcon.png";
import contactManagementImage from "./Images/Contact management.png";
import contactManagementIcon from "./Images/Contact ManagIcon.png";
import verifyImage from "./Images/verifiedImg.png";
import verifyIcon from "./Images/VerificationIcon.png";
import whatsappFormImage from "./Images/WhatsAppForm.png";
import whatsappFormicon from "./Images/formsIcon.png";
import dataStorageImage from "./Images/DataStorage.png";
import dataStorageIcon from "./Images/SecureDataIcon.png";
import broadCastingImage from "./Images/Broadcasting.png";
import broadCastingIcon from "./Images/BroadcastingIcon.png";
import analyticsImage from "./Images/Analytics.png";
import analyticsIcon from "./Images/AnalyticsIcon.png";

const CardSection = () => {
    return (
        <section className="py-5 position-relative mb-5" style={{ overflow: 'hidden', }}>
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-5" >
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Single <span style={{ color: '#1DB954' }}>platform, </span>
                        infinite ways to grow your business
                    </h2>
                </div>

                {/* Card1 + Center 2x2 Cards */}
                <div className="d-flex flex-wrap justify-content-between" style={{ gap: "14px" }}>
                    {/* Card1 */}
                    <div style={{ width: "25%" }}>
                        <div className="w-100 h-100 border rounded text-center p-3" style={{ background: "#E1EFFF", height: '660px' }}>
                            <img src={chatbotIcon} alt="Chatbot Icon" style={{ width: "42px" }} />
                            <h5 className="fw-bold mt-3"
                                style={{
                                    fontSize: "22px",
                                    color: "#323030ff",
                                    fontWeight: 600,
                                    fontFamily: "Inter",
                                    paddingRight: '30px'
                                }}
                            >
                                No-code chatbot builder
                            </h5>
                            <p
                                style=
                                {{
                                    paddingLeft: '4px',
                                    fontSize: '16px',
                                    fontFamily: "Inter",
                                    lineHeight: "1.2",
                                    fontWeight: 350,
                                    textAlign: 'left',
                                    color: '#404040',
                                }}
                            >
                                Build intelligent chatbots effortlessly no coding required- with a simple and intuitive drag-and-drop interface.
                            </p>
                            <img src={chatbotImage} alt="Chatbot Flow" style={{ width: "100%", marginTop: "20px" }} />
                        </div>
                    </div>

                    {/* 2x2 Grid Cards */}
                    <div style={{ width: "calc(75% - 16px)", display: 'flex', flexDirection: 'column', gap: "14px" }}>
                        {/* Row 1 */}
                        <div style={{ display: 'flex', gap: "14px" }}>
                            {/* Card2 */}
                            <div className="border rounded text-start p-3" style={{ background: "#EAFBF1", width: "calc(50% - 8px)" }}>
                                <div className="d-flex justify-content-between align-items-start h-100">
                                    <div style={{ width: "55%" }}>
                                        <img src={contactManagementIcon} alt="Contact Icon" style={{ width: "42px" }} />
                                        <h6 className="fw-bold mt-3"
                                            style={{
                                                fontSize: "22px",
                                                color: "#323030ff",
                                                fontWeight: 600,
                                                fontFamily: "Inter",
                                                paddingLeft: '5px'
                                            }}
                                        >
                                            Advanced contact management
                                        </h6>
                                        <p
                                            style=
                                            {{
                                                paddingLeft: '6px',
                                                fontSize: '16px',
                                                fontFamily: "Inter",
                                                lineHeight: "1.2",
                                                fontWeight: 350,
                                                textAlign: 'left',
                                                color: '#404040',
                                            }}
                                        >
                                            Organize and segment your audience with custom tags, dynamic lists and automated syncing.
                                        </p>
                                    </div>
                                    <div style={{ width: "40%" }}>
                                        <img src={contactManagementImage} alt="Contact Management" style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </div>

                            {/* Card3 */}
                            <div className="border rounded text-start p-3" style={{ background: "#F5F1EE", width: "calc(50% - 8px)" }}>
                                <div className="d-flex justify-content-between align-items-start h-100">
                                    <div style={{ width: "55%" }}>
                                        <img src={verifyIcon} alt="Verified Icon" style={{ width: "42px" }} />
                                        <h6 className="fw-bold mt-3"
                                            style={{
                                                fontSize: "22px",
                                                color: "#323030ff",
                                                fontWeight: 600,
                                                fontFamily: "Inter",
                                                paddingLeft: '5px'
                                            }}
                                        >
                                            Verified business account badge
                                        </h6>
                                        <p style={{
                                            paddingLeft: '6px',
                                            fontSize: '16px',
                                            fontFamily: "Inter",
                                            lineHeight: "1.2",
                                            fontWeight: 350,
                                            textAlign: 'left',
                                            color: '#404040',
                                        }}
                                        >
                                            Build trust and authenticity by displaying the verified badge to your customers.
                                        </p>
                                    </div>
                                    <div style={{ width: "40%" }}>
                                        <img src={verifyImage} alt="Verified Badge" style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Row 2 */}
                        <div style={{ display: 'flex', gap: "14px" }}>
                            {/* Card4 */}
                            <div className="border rounded text-start p-3" style={{ background: "#E2E9F0", width: "calc(50% - 8px)" }}>
                                <div className="d-flex justify-content-between align-items-start h-100">
                                    <div style={{ width: "55%" }}>
                                        <img src={whatsappFormicon} alt="Form Icon" style={{ width: "42px" }} />
                                        <h6 className="fw-bold mt-3"
                                            style={{
                                                fontSize: "22px",
                                                color: "#323030ff",
                                                fontWeight: 600,
                                                fontFamily: "Inter",
                                                paddingLeft: '5px'
                                            }}
                                        >
                                            Build automated WhatsApp forms
                                        </h6>
                                        <p style={{
                                            paddingLeft: '6px',
                                            fontSize: '16px',
                                            fontFamily: "Inter",
                                            lineHeight: "1.2",
                                            fontWeight: 350,
                                            textAlign: 'left',
                                            color: '#404040',
                                        }}
                                        >
                                            Collect customer data effortlessly with WhatsApp forms.
                                        </p>
                                    </div>
                                    <div style={{ width: "40%" }}>
                                        <img src={whatsappFormImage} alt="Form" style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </div>

                            {/* Card5 */}
                            <div className="border rounded text-start p-3" style={{ background: "#E3E9FF", width: "calc(50% - 8px)" }}>
                                <div className="d-flex justify-content-between align-items-start h-100">
                                    <div style={{ width: "55%" }}>
                                        <img src={dataStorageIcon} alt="Data Icon" style={{ width: "42px" }} />
                                        <h6 className="fw-bold mt-3"
                                            style={{
                                                fontSize: "22px",
                                                color: "#323030ff",
                                                fontWeight: 600,
                                                fontFamily: "Inter",
                                                paddingLeft: '5px'
                                            }}
                                        >
                                            Secure with local data storage
                                        </h6>
                                        <p style=
                                            {{
                                                paddingLeft: '6px',
                                                fontSize: '16px',
                                                fontFamily: "Inter",
                                                lineHeight: "1.2",
                                                fontWeight: 350,
                                                textAlign: 'left',
                                                color: '#404040',
                                            }}
                                        >
                                            Keep all data private and secure on your own servers or devices.
                                        </p>
                                    </div>
                                    <div style={{ width: "40%" }}>
                                        <img src={dataStorageImage} alt="Data Storage" style={{ width: "100%" }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Row (Card6 + Card7) */}
                <div className="d-flex justify-content-between mt-3" style={{ gap: "14px" }}>
                    {/* Card6 */}
                    <div style={{ width: "calc(50% - 8px)" }}>
                        <div className="border rounded text-start p-3" style={{ backgroundColor: "#EAEFEB", height: "300px" }}>
                            <div className="d-flex justify-content-between align-items-start h-100">
                                <div style={{ width: "55%" }}>
                                    <img src={broadCastingIcon} alt="Broadcast Icon" style={{ width: "42px" }} />
                                    <h6 className="fw-bold mt-3"
                                        style={{
                                            fontSize: "22px",
                                            color: "#323030ff",
                                            fontWeight: 600,
                                            fontFamily: "Inter",
                                            paddingLeft: '5px'
                                        }}
                                    >
                                        Smart broadcasting and customer retargeting
                                    </h6>
                                    <p style={{
                                        paddingLeft: '6px',
                                        fontSize: '16px',
                                        fontFamily: "Inter",
                                        lineHeight: "1.2",
                                        fontWeight: 350,
                                        textAlign: 'left',
                                        color: '#404040',
                                    }}
                                    >
                                        Send personalized messages and re-engage interested customers automatically.
                                    </p>
                                </div>
                                <div style={{ width: "40%" }}>
                                    <img src={broadCastingImage} alt="Broadcasting" style={{ width: "100%" }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Card7 */}
                    <div style={{ width: "calc(50% - 8px)" }}>
                        <div className="border rounded text-start p-3" style={{ backgroundColor: "#eee2c8", height: "300px" }}>
                            <div className="d-flex justify-content-between align-items-start h-100">
                                <div style={{ width: "55%" }}>
                                    <img src={analyticsIcon} alt="Analytics Icon" style={{ width: "42px" }} />
                                    <h6 className="fw-bold mt-3"
                                        style={{
                                            fontSize: "22px",
                                            color: "#323030ff",
                                            fontWeight: 600,
                                            fontFamily: "Inter",
                                            paddingLeft: '5px'
                                        }}
                                    >
                                        Real-time analytics dashboard
                                    </h6>
                                    <p style={{
                                        paddingLeft: '6px',
                                        fontSize: '16px',
                                        fontFamily: "Inter",
                                        lineHeight: "1.2",
                                        fontWeight: 350,
                                        textAlign: 'left',
                                        color: '#404040',
                                    }}
                                    >
                                        Track campaign performance instantly and make data-driven decisions.
                                    </p>
                                </div>
                                <div style={{ width: "40%" }}>
                                    <img src={analyticsImage} alt="Analytics" style={{ width: "100%" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CardSection;

